import React from "react";
import { useDispatch } from "react-redux";
import { Dialog, useMediaQuery, useTheme } from "@mui/material";
import { closeModal } from "../../../store/reducers/modalConductor";

const ModalWrapper = (props) => {
  const { disableBackdropClick } = props;
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  // Compact modals (e.g. the tiebreaker form) opt out of the mobile full-screen
  // treatment via disableFullScreen, so they render as a centered card that
  // fits their content instead of being stretched to 100vh — which pushed the
  // submit button off-screen on iPhone.
  const fullScreen = isMobile && !props.disableFullScreen;

  const handleClose = (event, reason) => {
    if (disableBackdropClick) {
      if (reason !== "backdropClick") {
        if (props.onClose) props.onClose();
        dispatch(closeModal());
      }
    } else {
      if (props.onClose) props.onClose();
      dispatch(closeModal());
    }
  };

  return (
    <Dialog
      disableRestoreFocus
      disableEnforceFocus={props.disableEnforceFocus}
      hideBackdrop={props.hideBackdrop}
      disableScrollLock={props.disableScrollLock}
      open={props.show}
      fullScreen={fullScreen}
      maxWidth={props.size || false}
      fullWidth={!fullScreen && isMobile}
      onClose={handleClose}
      slotProps={{
        paper: {
          sx: [
            {
              borderRadius: fullScreen ? 0 : "16px",
              ...(!fullScreen && isMobile ? { margin: "16px", width: "calc(100% - 32px)", maxHeight: "calc(100% - 32px)" } : {}),
              backgroundColor: theme.branding.gray[0],
              boxShadow: "0 24px 60px -20px rgba(15,23,42,0.35)",
            },
            (theme) =>
              theme.applyStyles("dark", {
                backgroundColor: theme.branding.darkBlue[800],
                boxShadow: "0 24px 60px -20px rgba(0,0,0,0.6)",
              }),
          ],
        },
        container: {
          sx: {},
        },
      }}
    >
      {props.children}
    </Dialog>
  );
};

export default ModalWrapper;
